import { render } from "./BloodDonationsReportTab.vue?vue&type=template&id=5b45300a&scoped=true"
import script from "./BloodDonationsReportTab.vue?vue&type=script&lang=js"
export * from "./BloodDonationsReportTab.vue?vue&type=script&lang=js"

import "./BloodDonationsReportTab.vue?vue&type=style&index=0&id=5b45300a&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b45300a"]])

export default __exports__